/**
 * Get filtered list of suppliers based on product type.
 *
 * @param state
 * @returns {Array}
 */
export const getSuppliersInProductType = (state) => {
    const productType = state.productType;
    const suppliersProducts = state.suppliersProducts.items || [];
    return suppliersProducts[productType] || [];
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js